import { render, staticRenderFns } from "./scorePoint.vue?vue&type=template&id=9184d94e"
import script from "./scorePoint.vue?vue&type=script&lang=js"
export * from "./scorePoint.vue?vue&type=script&lang=js"
import style0 from "./scorePoint.vue?vue&type=style&index=0&id=9184d94e&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports